import ActionTypes from "../Actions/ActionTypes";

let initialState = {
  notifications: null,
  unReadNotification: 0,
};

const NotificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_NOTIFICATIONS:
      state = {
        ...state,
        notifications: action.payload,
        unReadNotification: 0,
      };
      break;
    case ActionTypes.GET_UNREAD_NOTIFICATIONS:
      state = { ...state, unReadNotification: action.payload };
      break;
    default:
      break;
  }
  return state;
};

export default NotificationReducer;
